import { Tooltip as FrameworkTooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from 'components/v2/icons/InfoIcon';
import { getClassName } from 'utils/ui/classes';
const Tooltip = ({ id, content, children, position, tooltipClassName, className, }) => {
    return (React.createElement(TooltipProvider, null,
        React.createElement(FrameworkTooltip, { id: id },
            React.createElement(TooltipTrigger, { className: getClassName('block text-left', className) }, children),
            React.createElement(TooltipContent, { side: position, style: { zIndex: 999999 }, className: classNames(tooltipClassName) }, content))));
};
const positions = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
};
Tooltip.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node,
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    position: PropTypes.oneOf(Object.keys(positions)),
    tooltipClassName: PropTypes.string,
};
Tooltip.defaultProps = {
    position: positions.top,
    children: React.createElement(InfoIcon, { className: "w-5 h-5" }),
    tooltipClassName: 'max-w-lg',
};
export default Tooltip;
